"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoomUpgradesDto = instanceOfRoomUpgradesDto;
exports.RoomUpgradesDtoFromJSON = RoomUpgradesDtoFromJSON;
exports.RoomUpgradesDtoFromJSONTyped = RoomUpgradesDtoFromJSONTyped;
exports.RoomUpgradesDtoToJSON = RoomUpgradesDtoToJSON;
exports.RoomUpgradesDtoToJSONTyped = RoomUpgradesDtoToJSONTyped;
/**
 * Check if a given object implements the RoomUpgradesDto interface.
 */
function instanceOfRoomUpgradesDto(value) {
    if (!('room' in value) || value['room'] === undefined)
        return false;
    if (!('estimatedCost' in value) || value['estimatedCost'] === undefined)
        return false;
    if (!('estimatedValueAdd' in value) || value['estimatedValueAdd'] === undefined)
        return false;
    return true;
}
function RoomUpgradesDtoFromJSON(json) {
    return RoomUpgradesDtoFromJSONTyped(json, false);
}
function RoomUpgradesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'room': json['room'],
        'estimatedCost': json['estimatedCost'],
        'estimatedValueAdd': json['estimatedValueAdd'],
    };
}
function RoomUpgradesDtoToJSON(json) {
    return RoomUpgradesDtoToJSONTyped(json, false);
}
function RoomUpgradesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'room': value['room'],
        'estimatedCost': value['estimatedCost'],
        'estimatedValueAdd': value['estimatedValueAdd'],
    };
}
